export default __webpack_public_path__ + "static/media/dai.ae64f1f6.svg";